var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgXrp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    viewBox: "0 0 2500 2500",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1250,
    cy: 1250,
    r: 1250
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1820.4 549.8h233.2l-485.5 503.4c-175.8 182.3-460.8 182.3-636.2 0L446.3 549.8h233.2l368.7 382.4c111.5 115.3 291.8 115.3 403 0l369.2-382.4zM676.6 1950.2H443.3l488.6-506.8c175.8-182.3 460.8-182.3 636.6 0l488.6 506.8h-233.3L1452 1564.4c-111.5-115.3-291.8-115.3-403 0l-372.4 385.8z",
    style: {
      fill: "#fff"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgXrp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/xrp.a39eabeb7b99691190a0a8a7f484476f.svg";